import { ValuationStatus } from "../valuation";
import { Holding } from "./types";

/**
 * Rebuilds the shared `ValuationStatus` shape from a holding's (or the summary's) flat wire
 * fields, so it can use the same copy helpers (`valuationMessageFor`,
 * `isPendingValuation`) as every other surface that shows a valuation.
 */
export const valuationStatusOf = (
  row: Pick<
    Holding,
    "valuationState" | "valuationStateReason" | "valuationAsOf"
  >,
): ValuationStatus => ({
  state: row.valuationState,
  reason: row.valuationStateReason,
  asOf: row.valuationAsOf,
});
